// extracted by css-extract-rspack-plugin
export default {"variablesDialog":"VariablesDialog-module__variablesDialog__InEtY","DialogOverflowWrapper":"VariablesDialog-module__DialogOverflowWrapper__oLfiN"};